import React from "react"
import {ProductApplication} from "../../resources/productApplication"
import {useCanViewProductApplicationDecision} from "../../containers/PermissionedUser/PermissionedUser"
import {ApplicationDecision} from "./ApplicationDecision"

export function ProductApplicationDecision({
	application,
	fieldClassName,
}: {
	application: ProductApplication
	fieldClassName?: string
}) {
	const canViewDecision = useCanViewProductApplicationDecision()
	const {status, decisionMethod, decisionDateTime, decisionReason, decisionUserId, decisionBy} = application.attributes

	return (
		<ApplicationDecision
			canViewDecision={canViewDecision}
			status={status}
			decisionMethod={decisionMethod}
			decisionDateTime={decisionDateTime}
			decisionReason={decisionReason}
			decisionUserId={decisionUserId}
			decisionBy={decisionBy}
			showEvaluationType={false}
			fieldClassName={fieldClassName}
		/>
	)
}
